import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import AttentionIcon from '../../assets/attention.svg?react';
import TrafficLightRed from '../../assets/trafficlight_red.svg?react';
import TrafficLightYellow from '../../assets/trafficlight_yellow.svg?react';
import TrafficLightGreen from '../../assets/trafficlight_green.svg?react';
import CloseIcon from '../../assets/cancel.svg?react';
import CheckedIcon from '../../assets/check-circle.svg?react';
import ArrowLeft from '../../assets/chevron-left.svg?react';
import ArrowRight from '../../assets/chevron-right.svg?react';
import DeleteIcon from '../../assets/delete.svg?react';
import DisabledIcon from '../../assets/disabled.svg?react';
import DownloadIcon from '../../assets/download.svg?react';
import FileDownload from '../../assets/file_save.svg?react';
import EditIcon from '../../assets/edit.svg?react';
import FilterIcon from '../../assets/filter_list.svg?react';
import LoadingCircle from '../../assets/loading.svg?react';
import PendingIcon from '../../assets/pending.svg?react';
import AddIcon from '../../assets/plus.svg?react';
import SaveIcon from '../../assets/save.svg?react';
import SearchIcon from '../../assets/search.svg?react';
import UpArrow from '../../assets/up_arrow.svg?react';
import PalmTreeIcon from '../../assets/palm-tree.svg?react';
import TimeIcon from '../../assets/time.svg?react';
import PreviewIcon from '../../assets/eye.svg?react';
import ApprovedIcon from '../../assets/approved.svg?react';
import DeniedIcon from '../../assets/cancel.svg?react';
import DocumentIcon from '../../assets/document.svg?react';
import EuroIcon from '../../assets/euro.svg?react';
import MailIcon from '../../assets/mail.svg?react';
import ExchangeIcon from '../../assets/exchange.svg?react';
import ErrorIcon from '../../assets/error.svg?react';
import UserIcon from '../../assets/user.svg?react';
import Exclamation from '../../assets/exclamation.svg?react';
import LockClosed from '../../assets/lock_closed.svg?react';
import LockOpen from '../../assets/lock_open.svg?react';
import CopyIcon from '../../assets/copy.svg?react';
import DescriptionIcon from '../../assets/addDocument.svg?react';
import ProtocolIcon from '../../assets/protocol.svg?react';
import ArrowRange from '../../assets/arrow_range.svg?react';
import CarIcon from '../../assets/delivery.svg?react';
import UpdateIcon from '../../assets/update.svg?react';
import TodayIcon from '../../assets/today.svg?react';
import TableIcon from '../../assets/table.svg?react';
import UploadIcon from '../../assets/upload_file.svg?react';
export enum IconType {
  TABLE = 'TABLE',
  EDIT = 'EDIT',
  ADD = 'ADD',
  DELETE = 'DELETE',
  ATTENTION = 'ATTENTION',
  UP_ARROW = 'UP_ARROW',
  ARROW_LEFT = 'ARROW_LEFT',
  ARROW_RIGHT = 'ARROW_RIGHT',
  SAVE = 'SAVE',
  FILTER = 'FILTER',
  LOADING = 'LOADING',
  DISABLED = 'DISABLED',
  DOWNLOAD = 'DOWNLOAD',
  DOWNLOAD_FILE = 'DOWNLOAD_FILE',
  CLOSE = 'CLOSE',
  PENDING = 'PENDING',
  SEARCH = 'SEARCH',
  CHECKED = 'CHECKED',
  PALM_TREE = 'PALM_TREE',
  TIME = 'TIME',
  PREVIEW = 'PREVIEW',
  APPROVED = 'APPROVED',
  DENIED = 'DENIED',
  DOCUMENT = 'DOCUMENT',
  EURO = 'EURO',
  MAIL = 'MAIL',
  EXCHANGE = 'EXCHANGE',
  ERROR = 'ERROR',
  USER = 'USER',
  EXCLAMATION = 'EXCLEMATION',
  LOCK_CLOSED = 'LOCK_CLOSED',
  LOCK_OPEN = 'LOCK_OPEN',
  COPY = 'COPY',
  DESCRIPTION = 'DESCRIPTION',
  PROTOCOL = 'PROTOCOL',
  ARROW_RANGE = 'ARROW_RANGE',
  CAR = 'CAR',
  UPDATE = 'UPDATE',
  TODAY = 'TODAY',
  UPLOAD = 'UPLOAD',
  TRAFFIC_LIGHT_RED = 'TRAFFIC_LIGHT_RED',
  TRAFFIC_LIGHT_YELLOW = 'TRAFFIC_LIGHT_YELLOW',
  TRAFFIC_LIGHT_GREEN = 'TRAFFIC_LIGHT_GREEN',
}
export const IconComponent: React.FC<
  { type: IconType; title?: string } & React.SVGProps<SVGSVGElement>
> = ({ type, title, ...props }) => {
  const { t } = useTranslation();

  /**
   * Get the correct icon for the given iconType
   */
  const Icon = useMemo(() => {
    switch (type) {
      case IconType.EDIT:
        return EditIcon;
      case IconType.ADD:
        return AddIcon;
      case IconType.DELETE:
        return DeleteIcon;
      case IconType.ATTENTION:
        return AttentionIcon;
      case IconType.UP_ARROW:
        return UpArrow;
      case IconType.ARROW_LEFT:
        return ArrowLeft;
      case IconType.ARROW_RIGHT:
        return ArrowRight;
      case IconType.SAVE:
        return SaveIcon;
      case IconType.FILTER:
        return FilterIcon;
      case IconType.LOADING:
        return LoadingCircle;
      case IconType.DISABLED:
        return DisabledIcon;
      case IconType.DOWNLOAD:
        return DownloadIcon;
      case IconType.DOWNLOAD_FILE:
        return FileDownload;
      case IconType.CLOSE:
        return CloseIcon;
      case IconType.PENDING:
        return PendingIcon;
      case IconType.SEARCH:
        return SearchIcon;
      case IconType.CHECKED:
        return CheckedIcon;
      case IconType.PALM_TREE:
        return PalmTreeIcon;
      case IconType.TIME:
        return TimeIcon;
      case IconType.PREVIEW:
        return PreviewIcon;
      case IconType.APPROVED:
        return ApprovedIcon;
      case IconType.DENIED:
        return DeniedIcon;
      case IconType.DOCUMENT:
        return DocumentIcon;
      case IconType.EURO:
        return EuroIcon;
      case IconType.EXCHANGE:
        return ExchangeIcon;
      case IconType.MAIL:
        return MailIcon;
      case IconType.ERROR:
        return ErrorIcon;
      case IconType.EXCLAMATION:
        return Exclamation;
      case IconType.LOCK_CLOSED:
        return LockClosed;
      case IconType.LOCK_OPEN:
        return LockOpen;
      case IconType.USER:
        return UserIcon;
      case IconType.COPY:
        return CopyIcon;
      case IconType.ARROW_RANGE:
        return ArrowRange;
      case IconType.CAR:
        return CarIcon;
      case IconType.DESCRIPTION:
        return DescriptionIcon;
      case IconType.PROTOCOL:
        return ProtocolIcon;
      case IconType.UPDATE:
        return UpdateIcon;
      case IconType.TODAY:
        return TodayIcon;
      case IconType.TABLE:
        return TableIcon;
      case IconType.UPLOAD:
        return UploadIcon;
      case IconType.TRAFFIC_LIGHT_RED:
        return TrafficLightRed;
      case IconType.TRAFFIC_LIGHT_YELLOW:
        return TrafficLightYellow;
      case IconType.TRAFFIC_LIGHT_GREEN:
        return TrafficLightGreen;
      default:
        return DisabledIcon;
    }
  }, [type, props]);
  return <Icon title={title || t(`general.icons.${type}`)} {...props} />;
};
